module.exports = __webpack_public_path__ + "static/banner-two-shape1-ba447a09760a60d8a1b4dd2eb8dde6e7.png";